import {useGetKpiValueQuery, useUpdateKpiValueMutation} from "../../apis/kpiApi";
import {DateTime} from "luxon";
import {InputNumber} from "primereact/inputnumber";
import _ from 'lodash';
import {useResponsibleHiearchicalList} from "../../hooks/taskHooks";
import {useUserProfileQuery} from "../../apis/authenticationApi";

const KPIValueTargetQuarterlyEntries = ({target, quarter}) => {
    const {data, isLoading} = useGetKpiValueQuery(target?.id);
    const [updateKpiValue] = useUpdateKpiValueMutation();
    const {data: userProfile} = useUserProfileQuery();
    const hierarchyUsers = useResponsibleHiearchicalList(userProfile?.company?.account);
    const editable = userProfile?.company?.role === "CompanyOwner" || 
                    (userProfile?.company?.account && hierarchyUsers?.length && hierarchyUsers.find(e => e.id && e.id === target?.responsible));

    if(isLoading) return (<></>);

    const quarterValues = [...((data?.values || [])[quarter] || [])];
    const quarterStart = DateTime.now()
        .set({years: target.year}).startOf('year')
        .plus({ months: quarter * 3 });
    const quarterEnd = quarterStart.endOf('quarter');
    const entries = [];
    let endOfWeek = quarterStart.endOf('week');
    let count = 0;
    let changed = false;

    const changeHandler = (index, value) => {
        quarterValues[index] = value;
        changed = true;
    }

    const submitChanges = () => {
        if(changed) {
            const updatedData = _.cloneDeep(data);

            updatedData.values[quarter] = quarterValues;
            updateKpiValue(updatedData);
        }

        changed = false;
    }

    const renderWeeklyEntry = (date, index) => {
        return (<div className="kpi-weekly-entry">
            <div className="kpi-week-label">{date.toFormat('d MMM')}</div>
            <div className="kpi-value-entry">
                {editable ?
                    (<InputNumber value={quarterValues[index]} maxFractionDigits={2}
                         onChange={(e) => changeHandler(index, e.value)} 
                         onBlur={() => submitChanges()}/>) :
                    (<div className="kpi-readonly-value">{quarterValues[index]}</div>)}
            </div>
        </div>)
    }

    while(endOfWeek < quarterEnd) {
        quarterValues[count] = quarterValues[count] || 0;
        entries.push(renderWeeklyEntry(endOfWeek, count));

        count++;
        endOfWeek = endOfWeek.plus({weeks: 1});
    }

    quarterValues[count] = quarterValues[count] || 0;
    entries.push(renderWeeklyEntry(quarterEnd, count))

    return (<div className="kpi-quarterly-entries">
        {entries}
    </div>)
}

export default KPIValueTargetQuarterlyEntries;
